export default __webpack_public_path__ + "static/media/background.545e1a72.jpg";